export default {"src":"/_next/static/media/telegram_color.1538f181.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};